import GamePad from "../assets/console/onmo_controller_1x.webp";
import GamePad2x from "../assets/console/onmo_controller_1x.webp";
import GamePad3x from "../assets/console/onmo_controller_3x.webp";
import MenuButtonIcon from "../assets/icons/menu_1x.webp";
import MenuButtonIcon2x from "../assets/icons/menu_2x.webp";
import MenuButtonIcon3x from "../assets/icons/menu_3x.webp";
import XButtonIcon from "../assets/icons/button_x_1x.webp";
import XButtonIcon2x from "../assets/icons/button_x_2x.webp";
import XButtonIcon3x from "../assets/icons/button_x_3x.webp";
import AButtonIcon from "../assets/icons/button_a_1x.webp";
import AButtonIcon2x from "../assets/icons/button_a_2x.webp";
import AButtonIcon3x from "../assets/icons/button_a_3x.webp";
import BButtonIcon from "../assets/icons/button_b_1x.webp";
import BButtonIcon2x from "../assets/icons/button_b_2x.webp";
import BButtonIcon3x from "../assets/icons/button_b_3x.webp";
import YButtonIcon3x from "../assets/icons/button_y_3x.webp";
import YButtonIcon2x from "../assets/icons/button_y_2x.webp";
import YButtonIcon from "../assets/icons/button_y_1x.webp";
import CircleButtonIcon from "../assets/icons/ps4_circle_1x.webp";
import CircleButtonIcon2x from "../assets/icons/ps4_circle_2x.webp";
import CircleButtonIcon3x from "../assets/icons/ps4_circle_3x.webp";
import TriangleButtonIcon from "../assets/icons/ps4_triangle_1x.webp";
import TriangleButtonIcon2x from "../assets/icons/ps4_triangle_2x.webp";
import TriangleButtonIcon3x from "../assets/icons/ps4_triangle_3x.webp";
import SquareButtonIcon from "../assets/icons/ps4_square_1x.webp";
import SquareButtonIcon2x from "../assets/icons/ps4_square_2x.webp";
import SquareButtonIcon3x from "../assets/icons/ps4_square_3x.webp";
import CrossButtonIcon from "../assets/icons/ps4_cross_1x.webp";
import CrossButtonIcon2x from "../assets/icons/ps4_cross_2x.webp";
import CrossButtonIcon3x from "../assets/icons/ps4_cross_3x.webp";
import KeyboardIcon from "../assets/icons/keyboard_1x.webp";
import KeyboardIcon2x from "../assets/icons/keyboard_2x.webp";
import KeyboardIcon3x from "../assets/icons/keyboard_3x.webp";
import F1Button from "../assets/icons/f1_button_1x.webp";
import F1Button2x from "../assets/icons/f1_button_2x.webp";
import F1Button3x from "../assets/icons/f1_button_3x.webp";
import F12Button from "../assets/icons/f12_button_1x.webp";
import F12Button2x from "../assets/icons/f12_button_2x.webp";
import F12Button3x from "../assets/icons/f12_button_3x.webp";
import ShiftButton from "../assets/icons/shift_button_1x.webp";
import ShiftButton2x from "../assets/icons/shift_button_2x.webp";
import ShiftButton3x from "../assets/icons/shift_button_3x.webp";
import EscButton from "../assets/icons/esc_button_1x.webp";
import EscButton2x from "../assets/icons/esc_button_2x.webp";
import EscButton3x from "../assets/icons/esc_button_3x.webp";
import EnterButton from "../assets/icons/enter_button_1x.webp";
import EnterButton2x from "../assets/icons/enter_button_2x.webp";
import EnterButton3x from "../assets/icons/enter_button_3x.webp";
import Remote from "../assets/console/remote_1x.webp";
import Remote2x from "../assets/console/remote_2x.webp";
import Remote3x from "../assets/console/remote_3x.webp";
import RemoteBack from "../assets/icons/remote_back_1x.webp";
import RemoteBack2x from "../assets/icons/remote_back_2x.webp";
import RemoteBack3x from "../assets/icons/remote_back_3x.webp";
import RemoteEnter from "../assets/icons/remote_enter_1x.webp";
import RemoteEnter2x from "../assets/icons/remote_enter_2x.webp";
import RemoteEnter3x from "../assets/icons/remote_enter_3x.webp";
import YVideoIcon1x from "../assets/icons/y_video_1x.webp";
import YVideoIcon2x from "../assets/icons/y_video_2x.webp";
import YVideoIcon3x from "../assets/icons/y_video_3x.webp";
import TriangleVideoIcon1x from "../assets/icons/triangle_video_1x.webp";
import TriangleVideoIcon2x from "../assets/icons/triangle_video_2x.webp";
import TriangleVideoIcon3x from "../assets/icons/triangle_video_3x.webp";
import F1VideoIcon1x from "../assets/icons/f1_video_1x.webp";
import F1VideoIcon2x from "../assets/icons/f1_video_2x.webp";
import F1VideoIcon3x from "../assets/icons/f1_video_3x.webp";
import VideoIcon1x from "../assets/icons/video_1x.webp";
import VideoIcon2x from "../assets/icons/video_2x.webp";
import VideoIcon3x from "../assets/icons/video_3x.webp";

import {
  findClosestElement,
  findNextElementByRowId,
  findNextRowElement,
  findStartElementByClientRect,
  getAllElementBySide,
} from "./screen";
import { isTizen, isTV } from "../utils/platform";
import { store } from "../store";
import { selectIsDesktopView } from "../store/slices/appState";
import {
  GENERAL_DETAIL_VIEWS,
  LEGAL_DETAIL_VIEWS,
  COOKIE_DETAIL_VIEWS,
  SCROLL_AMOUNT,
  SettingsView,
} from "../constants/settings";
import { activeElementsByPage } from "../contexts/GamepadProvider";
import { isMobile } from "react-device-detect";
import { getMenuGamepadId, getRoutePath } from "./location";

const IS_MOBILE_DEVICE = isMobile;

export type GamepadActionType =
  | "left"
  | "right"
  | "up"
  | "down"
  | "submit"
  | "back"
  | "menu"
  | "touchpad";

export type IGamePad = {
  id: string;
  type: "xbox" | "nintendo" | "sony" | "generic";
};

const iconSet = (
  icon1x: string,
  icon2x: string,
  icon3x: string,
  labelKey = "",
) => ({
  icon1x,
  icon2x,
  icon3x,
  labelKey,
});

export const getGameActionIcon = (
  inputMode?: string,
  gamepads?: IGamePad[],
) => {
  const gamePad = gamepads?.find((item) => item.type !== "generic");
  const isTouchDevice = "ontouchstart" in window;

  if ((!inputMode || inputMode === "remote") && isTV) {
    return {
      control: iconSet(Remote, Remote2x, Remote3x),
      buttonA: iconSet(
        RemoteEnter,
        RemoteEnter2x,
        RemoteEnter3x,
        "A11y_OK button",
      ),
      buttonB: iconSet(
        RemoteBack,
        RemoteBack2x,
        RemoteBack3x,
        "A11y_Back button",
      ),
      menu: iconSet(RemoteBack, RemoteBack2x, RemoteBack3x, "A11y_Back button"),
    };
  }

  if (
    (inputMode === "mouse" && !isTouchDevice) ||
    (!inputMode && !isTV && !gamePad)
  ) {
    return {
      control: iconSet(KeyboardIcon, KeyboardIcon2x, KeyboardIcon3x),
      menu: iconSet(F12Button, F12Button2x, F12Button3x, "A11y_F12 key"),
      menuShift: iconSet(
        ShiftButton,
        ShiftButton2x,
        ShiftButton3x,
        "A11y_Shift",
      ),
      buttonA: iconSet(
        EnterButton,
        EnterButton2x,
        EnterButton3x,
        "A11y_Enter key",
      ),
      buttonB: iconSet(EscButton, EscButton2x, EscButton3x, "A11y_Esc key"),
      buttonY: iconSet(F1Button, F1Button2x, F1Button3x, "A11y_F1 key"),
    };
  }

  if (gamePad?.type === "sony") {
    return {
      control: iconSet(GamePad, GamePad2x, GamePad3x),
      menu: iconSet(
        MenuButtonIcon,
        MenuButtonIcon2x,
        MenuButtonIcon3x,
        "A11y_Menu button",
      ),
      buttonA: iconSet(
        CrossButtonIcon,
        CrossButtonIcon2x,
        CrossButtonIcon3x,
        "A11y_Cross button",
      ),
      buttonB: iconSet(
        CircleButtonIcon,
        CircleButtonIcon2x,
        CircleButtonIcon3x,
        "A11y_Circle button",
      ),
      buttonX: iconSet(
        SquareButtonIcon,
        SquareButtonIcon2x,
        SquareButtonIcon3x,
        "A11y_Square button",
      ),
      buttonY: iconSet(
        TriangleButtonIcon,
        TriangleButtonIcon2x,
        TriangleButtonIcon3x,
        "A11y_Triangle button",
      ),
    };
  }

  return {
    control: iconSet(GamePad, GamePad2x, GamePad3x),
    menu: iconSet(
      MenuButtonIcon,
      MenuButtonIcon2x,
      MenuButtonIcon3x,
      "A11y_Menu button",
    ),
    buttonA: iconSet(
      AButtonIcon,
      AButtonIcon2x,
      AButtonIcon3x,
      "A11y_A button",
    ),
    buttonB: iconSet(
      BButtonIcon,
      BButtonIcon2x,
      BButtonIcon3x,
      "A11y_B button",
    ),
    buttonX: iconSet(
      XButtonIcon,
      XButtonIcon2x,
      XButtonIcon3x,
      "A11y_X button",
    ),
    buttonY: iconSet(
      YButtonIcon,
      YButtonIcon2x,
      YButtonIcon3x,
      "A11y_Y button",
    ),
  };
};

export const getSnackbarVideoGuideIcon = (inputMode?: string) => {
  if (IS_MOBILE_DEVICE && inputMode !== "gamepad") {
    return iconSet(VideoIcon1x, VideoIcon2x, VideoIcon3x);
  }

  if (inputMode === "remote") {
    return iconSet(VideoIcon1x, VideoIcon2x, VideoIcon3x);
  }

  if (inputMode === "mouse") {
    return iconSet(F1VideoIcon1x, F1VideoIcon2x, F1VideoIcon3x);
  }

  const gamePad = getGamepadsConnected()?.find(
    (item) => item?.type !== "generic",
  );

  if (gamePad?.type === "sony") {
    return iconSet(
      TriangleVideoIcon1x,
      TriangleVideoIcon2x,
      TriangleVideoIcon3x,
    );
  }

  return iconSet(YVideoIcon1x, YVideoIcon2x, YVideoIcon3x);
};

export const getTypeGamepad = (id: string) => {
  // Detect specific gamepad models first (before vendor ID checks)
  const gamepadPatterns = {
    sony: /dualshock|dualsense|playstation|ps[3-5]/i,
    xbox: /xbox|x-box|xinput|standard gamepad/i,
    nintendo: /nintendo|joy-con|pro controller|switch/i,
  };

  if (gamepadPatterns.sony.test(id)) return "sony";
  if (gamepadPatterns.xbox.test(id)) return "xbox";
  if (gamepadPatterns.nintendo.test(id)) return "nintendo";

  // Remote/TV patterns - check before vendor ID fallback
  if (/remote|bravia|samsung|tizen|webos|lg gamepad/i.test(id)) {
    return "generic";
  }

  // Vendor ID based detection - only if no specific model name matched
  // 054c = Sony, but could be TV remote or gamepad
  // Check for gamepad-specific product IDs under Sony vendor
  if (/054c/i.test(id)) {
    // Known DualShock/DualSense product IDs
    const sonyGamepadProducts = /0268|05c4|09cc|0ba0|0ce6|0df2|0e5f|0e20/i;
    if (sonyGamepadProducts.test(id)) return "sony";
    // If it has 054c but no known gamepad product ID, it's likely a TV remote
    return "generic";
  }
  if (/057e/i.test(id)) return "nintendo";

  // SHANWAN vendor ID (2563) - Xbox-compatible controllers
  if (/2563/i.test(id)) return "xbox";

  // DualShock 4 often reports as "Wireless Controller" without vendor ID on some TVs
  if (/^wireless controller$/i.test(id.trim())) return "sony";

  // Onmo wireless controller
  if (/onmo/i.test(id.trim())) return "xbox";

  // EvoFox controllers (report as xinput-compatible)
  if (/evofox/i.test(id.trim())) return "xbox";

  // SHANWAN controllers (Xbox-compatible Android gamepads)
  if (/shanwan/i.test(id.trim())) return "xbox";

  return "generic";
};

export const getGamepadsConnected = () => {
  const _gpList = navigator.getGamepads();
  const gamepads: IGamePad[] = [];
  for (let i = 0; i < 4; i++) {
    const gp = _gpList[i];
    if (gp) {
      const isUnknown = /Unknown Gamepad/i.test(gp.id.trim());
      if (!isUnknown) {
        gamepads.push({ id: gp.id, type: getTypeGamepad(gp.id) });
      }
    }
  }
  return gamepads;
};

const countPressedButtons = (gp: Gamepad): number => {
  let count = 0;
  for (let i = 0; i < gp.buttons.length; i++) {
    if (gp.buttons[i].pressed) count++;
  }
  return count;
};

export type GamepadActionResult = {
  action?:
    | "up"
    | "down"
    | "left"
    | "right"
    | "submit"
    | "back"
    | "x-square"
    | "y-triangle"
    | "lb-l1"
    | "rb-r1"
    | "lt-l2"
    | "rt-r2"
    | "menu"
    | "touchpad"
    | "home"
    | "other";
  gamepadType?: IGamePad["type"];
};

export const onGamepadAction = (
  gpList?: ReturnType<typeof navigator.getGamepads>,
  justPressedButtons?: ReadonlySet<number>,
): GamepadActionResult => {
  const _gpList = gpList ?? navigator.getGamepads();
  const gps: Gamepad[] = [];
  for (let i = 0; i < 4; i++) {
    if (_gpList[i]) gps.push(_gpList[i]!);
  }
  if (gps.length <= 0) return { action: undefined, gamepadType: undefined };

  let result: GamepadActionResult | undefined;

  for (const gp of gps) {
    const gamepadType = getTypeGamepad(gp.id);

    // Check if the left stick is moved vertical or horizontal
    // Lower threshold for horizontal movement and prioritize horizontal over vertical
    const horizontalThreshold = 0.3; // More sensitive for left/right
    const verticalThreshold = 0.5; // Keep normal sensitivity for up/down

    const horizontalInput = Math.abs(gp?.axes[0]);
    const verticalInput = Math.abs(gp?.axes[1]);

    const isStandardMapping = gp.mapping === "standard";
    const isTizenXbox = isTizen && gamepadType === "xbox";
    const isMenuPressed = isStandardMapping
      ? gp.buttons?.[9]?.pressed
      : isTizenXbox
      ? gp.buttons?.[5]?.pressed
      : gp.buttons?.[9]?.pressed;

    let action: GamepadActionResult["action"] | undefined;

    // Prioritize horizontal movement when both axes are active
    if (
      horizontalInput > horizontalThreshold &&
      horizontalInput >= verticalInput
    ) {
      action = gp?.axes[0] > 0 ? "right" : "left";
    } else if (verticalInput > verticalThreshold) {
      action = gp?.axes[1] > 0 ? "down" : "up";
    } else if (gp.buttons?.[12]?.pressed) {
      // D-pad up
      action = "up";
    } else if (gp.buttons?.[13]?.pressed) {
      // D-pad down
      action = "down";
    } else if (gp.buttons?.[14]?.pressed) {
      // D-pad left
      action = "left";
    } else if (gp.buttons?.[15]?.pressed) {
      // D-pad right
      action = "right";
    } else if (gp.buttons?.[16]?.pressed) {
      // Menu/Ps b
      action = "home";
    } else if (gp.buttons?.[17]?.pressed) {
      // Touchpad play station
      action = "touchpad";
    } else if (
      (justPressedButtons?.has(0) ?? false) &&
      countPressedButtons(gp) === 1
    ) {
      // A-Cross button (only one button pressed)
      action = "submit";
    } else if (gp.buttons?.[1]?.pressed) {
      // B-Circle button
      action = "back";
    } else if (gp.buttons?.[2]?.pressed) {
      // X-Square button
      action = "x-square";
    } else if (gp.buttons?.[3]?.pressed) {
      // Y-Triangle button
      action = "y-triangle";
    } else if (gp.buttons?.[4]?.pressed) {
      // LB / L1 button
      action = "lb-l1";
    } else if (gp.buttons?.[5]?.pressed) {
      action = "rb-r1";
    } else if (gp.buttons?.[6]?.pressed) {
      // LT / L2 trigger
      action = "lt-l2";
    } else if (gp.buttons?.[7]?.pressed) {
      // RT / R2 trigger
      action = "rt-r2";
    } else if (isMenuPressed) {
      // Menu button
      action = "menu";
    } else if (gp.buttons?.find((b) => b?.pressed)) {
      // Other buttons
    }

    if (action) {
      result = { action, gamepadType };
      break;
    }
  }

  return result || { action: undefined, gamepadType: undefined };
};

export type MoveAction = "left" | "right" | "up" | "down";
const hasNavigationBar = () => selectIsDesktopView(store.getState());

const getGamepadElementContext = (activeElement: HTMLElement) => {
  const allGamepadElements = document?.querySelectorAll("[data-gamepad]");
  const listElement = Array.from(allGamepadElements || []) as HTMLElement[];
  const listMenuElement = listElement.filter((item) =>
    item.getAttribute("data-gamepad")?.startsWith("menu-"),
  );
  const listContentElement = listElement.filter(
    (item) => !item.getAttribute("data-gamepad")?.startsWith("menu-"),
  );
  const activeDataGamepad = activeElement.getAttribute("data-gamepad");
  const currentActiveMenuElement = listMenuElement.find(
    (item) => item.getAttribute("data-gamepad") === getMenuGamepadId(),
  );
  const isActiveMenu = activeDataGamepad?.startsWith("menu-");

  return {
    listElement,
    listMenuElement,
    listContentElement,
    activeDataGamepad,
    currentActiveMenuElement,
    isActiveMenu,
    activeElement,
  };
};
export const getNextElement = (
  listElement: HTMLElement[],
  activeElement: HTMLElement,
  action: MoveAction,
) => {
  const allElementBySide = getAllElementBySide(
    activeElement,
    action,
    listElement,
  );
  const nextElement = findClosestElement(
    activeElement,
    action,
    allElementBySide,
  );
  return nextElement;
};
// Navbar items that are not pages: moving onto them must not click them
const NAVBAR_ACTION_IDS = ["menu-logout", "menu-profile-switcher"];

export const isNavbarAction = (dataGamepad?: string | null) =>
  NAVBAR_ACTION_IDS.includes(dataGamepad ?? "");

const handleMenuNavigation = (
  ctx: ReturnType<typeof getGamepadElementContext>,
  action: MoveAction,
): HTMLElement | undefined => {
  const { listMenuElement, listContentElement, activeElement } = ctx;

  if (action === "up") return;
  if (action === "left" || action === "right") {
    const nextElement = getNextElement(listMenuElement, activeElement, action);
    if (!isNavbarAction(nextElement?.getAttribute("data-gamepad")))
      nextElement?.click();
    return nextElement;
  } else if (hasNavigationBar()) {
    return listContentElement?.[0];
  }
};

export const onGameListMoveAction = (
  activeElement?: HTMLElement,
  action?: MoveAction,
): HTMLElement | undefined => {
  if (!activeElement || !action) return undefined;
  const ctx = getGamepadElementContext(activeElement);
  const {
    listElement,
    activeDataGamepad,
    isActiveMenu,
    listContentElement,
    currentActiveMenuElement,
  } = ctx;

  if (isActiveMenu) {
    return handleMenuNavigation(ctx, action);
  }

  const nextElement = getNextElement(listContentElement, activeElement, action);
  const nextElementDataGamepad = nextElement?.getAttribute("data-gamepad");
  if (action === "up" && !nextElement && hasNavigationBar()) {
    return currentActiveMenuElement;
  } else if (
    activeDataGamepad !== nextElementDataGamepad &&
    activeDataGamepad?.startsWith("game-card-") &&
    nextElementDataGamepad?.startsWith("game-card-")
  ) {
    if (action === "left" || action === "right") return undefined;
    const nextRowElements = findNextRowElement(
      activeElement,
      action,
      listElement,
    );
    const closestElementByRow = findStartElementByClientRect(nextRowElements);
    return closestElementByRow;
  } else {
    return nextElement;
  }
};

export const onDefaultMoveAction = (
  activeElement: HTMLElement,
  action: MoveAction,
): HTMLElement | undefined => {
  const ctx = getGamepadElementContext(activeElement);
  const { listContentElement, currentActiveMenuElement, isActiveMenu } = ctx;
  if (isActiveMenu) {
    return handleMenuNavigation(ctx, action);
  }

  const nextElement = getNextElement(listContentElement, activeElement, action);
  if (action === "up" && !nextElement && hasNavigationBar()) {
    return currentActiveMenuElement;
  } else {
    return nextElement;
  }
};

// Left/Right stay on the focused element's row; Up/Down use the default spatial nav
export const onRowMoveAction = (
  activeElement?: HTMLElement,
  action?: MoveAction,
): HTMLElement | undefined => {
  if (!activeElement || !action) return undefined;
  if (action === "up" || action === "down") {
    return onDefaultMoveAction(activeElement, action);
  }

  const { top, bottom } = activeElement.getBoundingClientRect();
  const { listContentElement } = getGamepadElementContext(activeElement);
  const sameRow = listContentElement.filter((element) => {
    const rect = element.getBoundingClientRect();
    return rect.top < bottom && rect.bottom > top;
  });
  return getNextElement(sameRow, activeElement, action);
};

const getFirstElementStartsWithId = (nextGamepadId: string) => {
  const firstElementById = document.querySelector(
    `[data-gamepad^="${nextGamepadId}"]`,
  ) as HTMLElement;
  return firstElementById;
};

export const onGameDetailMoveAction = (
  activeElement?: HTMLElement,
  action?: MoveAction,
): HTMLElement | undefined => {
  if (!activeElement || !action) return undefined;
  const ctx = getGamepadElementContext(activeElement);
  const {
    currentActiveMenuElement,
    isActiveMenu,
    activeDataGamepad,
    listContentElement,
  } = ctx;

  const hasReadMoreButton = listContentElement.find((item) =>
    item.getAttribute("data-gamepad")?.startsWith("read-more-"),
  );
  const listRowIds = hasReadMoreButton
    ? ["button-", "library-button", "read-more-", "game-media-"]
    : ["button-", "library-button", "game-media-"];
  const currentGamepadIdIndex = listRowIds.findIndex((id) =>
    activeDataGamepad?.startsWith(id),
  );

  if (isActiveMenu) {
    return handleMenuNavigation(ctx, action);
  }

  const nextElement = getNextElement(listContentElement, activeElement, action);

  if (!hasNavigationBar()) {
    return nextElement;
  }
  if (action === "up" && !nextElement && hasNavigationBar()) {
    return currentActiveMenuElement;
  }

  if (action === "up") {
    const nextGamepadId = listRowIds[currentGamepadIdIndex - 1];
    return getFirstElementStartsWithId(nextGamepadId);
  } else if (action === "down") {
    const nextGamepadId = listRowIds[currentGamepadIdIndex + 1];
    return getFirstElementStartsWithId(nextGamepadId);
  } else if (
    nextElement
      ?.getAttribute("data-gamepad")
      ?.startsWith(listRowIds[currentGamepadIdIndex])
  ) {
    return nextElement;
  }
};

export const onSearchMoveAction = (
  activeElement?: HTMLElement,
  action?: MoveAction,
): HTMLElement | undefined => {
  if (!activeElement || !action) return undefined;
  const ctx = getGamepadElementContext(activeElement);
  const {
    listContentElement,
    currentActiveMenuElement,
    isActiveMenu,
    activeDataGamepad,
  } = ctx;

  if (isActiveMenu) {
    return handleMenuNavigation(ctx, action);
  }

  if (activeDataGamepad?.startsWith("input-search")) {
    if (action === "down") {
      // Move focus from the search bar to the first game card.
      const firstGameCard = listContentElement.find((item) =>
        item.getAttribute("data-gamepad")?.startsWith("gameCard"),
      );
      return firstGameCard;
    } else if (action === "up" && hasNavigationBar()) {
      return currentActiveMenuElement;
    }
  }
  const nextElement = getNextElement(listContentElement, activeElement, action);
  if (
    (action === "up" &&
      !nextElement?.getAttribute("data-gamepad")?.startsWith("gameCard") &&
      activeDataGamepad?.startsWith("gameCard")) ||
    (activeDataGamepad?.startsWith("header-") && action === "down")
  ) {
    // Move focus to the search bar when navigating up from the first game card.
    const searchBarElement = listContentElement.find((item) =>
      item.getAttribute("data-gamepad")?.startsWith("input-search"),
    );
    return searchBarElement;
  } else {
    return nextElement;
  }
};

export const onSearchSuggestionMoveAction = (
  activeElement?: HTMLElement,
  action?: "left" | "right" | "up" | "down",
): HTMLElement | undefined => {
  if (!activeElement || !action) return undefined;
  const allGamepadElements = document
    .getElementById("search-suggestion")
    ?.querySelectorAll("[data-gamepad]");
  const searchInput = document.querySelector(
    '[data-gamepad="input-search"]',
  ) as HTMLElement;
  const listElement = (
    Array.from(allGamepadElements || []) as HTMLElement[]
  ).filter((item) => item !== activeElement);

  const nextElement = getNextElement(listElement, activeElement, action);
  if (activeElement.getAttribute("data-gamepad") === "input-search") {
    if (action === "down") return listElement[0];
  } else if (!nextElement && action === "up") {
    searchInput?.querySelector("input")?.focus();
    return searchInput;
  } else if (nextElement) {
    return nextElement;
  }
  return undefined;
};

const getDialogRows = (listElement: HTMLElement[]): HTMLElement[][] => {
  const rows: HTMLElement[][] = [];
  let rowBottom = 0;

  listElement.forEach((element) => {
    const { top, bottom } = element.getBoundingClientRect();
    const isSameRow = rows.length > 0 && top < rowBottom;

    if (isSameRow) {
      rows[rows.length - 1].push(element);
      rowBottom = Math.max(rowBottom, bottom);
    } else {
      rows.push([element]);
      rowBottom = bottom;
    }
  });

  return rows;
};

export const onMoveNextDialogElement = (data: {
  listElement: HTMLElement[];
  activeElement?: HTMLElement;
  action: "left" | "right" | "up" | "down";
}): HTMLElement | undefined => {
  const { listElement, activeElement, action } = data;

  if (!activeElement) {
    return listElement[0];
  }

  // Disable Left/Right navigation for the close-dialog element.
  if (
    (action === "left" || action === "right") &&
    activeElement.getAttribute("data-gamepad") === "close-dialog"
  ) {
    return undefined;
  }

  // Up/Down step one row, Left/Right stay inside the current row.
  if (activeElement.closest('[data-dialog-nav="rows"]')) {
    const rows = getDialogRows(listElement);
    const rowIndex = rows.findIndex((row) => row.includes(activeElement));
    const currentRow = rows[rowIndex] ?? [];

    if (action === "left" || action === "right") {
      return getNextElement(currentRow, activeElement, action);
    }
    const nextRow = rows[action === "up" ? rowIndex - 1 : rowIndex + 1];
    return nextRow?.[0];
  }

  const useSpatialNav = !!activeElement.closest('[data-dialog-nav="spatial"]');
  if (!useSpatialNav && activeElement.tagName === "BUTTON" && action === "up") {
    return listElement[0];
  }

  const allElementBySide = getAllElementBySide(
    activeElement,
    action,
    listElement,
  );
  const nextElement = findClosestElement(
    activeElement,
    action,
    allElementBySide,
  );

  if (!nextElement) {
    if (useSpatialNav) return undefined;
    return listElement.find((item) => item.tagName === "BUTTON");
  } else {
    return nextElement;
  }
};

export const isContentElement = (gamepad: string | null) =>
  gamepad &&
  !gamepad.startsWith("setting-menu-") &&
  !gamepad.startsWith("menu-");

const findFirstContentElement = (listElement: HTMLElement[]) =>
  listElement.find((item) => {
    const gp = item.getAttribute("data-gamepad");
    return gp && !gp.startsWith("setting-menu-") && !gp.startsWith("menu-");
  });

export const focusGamepadElementNextFrame = (
  selector: string,
  setActiveElement: (element: HTMLElement) => void,
) =>
  requestAnimationFrame(() => {
    const target = document.querySelector<HTMLElement>(selector);
    if (target) setActiveElement(target);
  });

export const onMoveSettingsAction = (
  activeElement: HTMLElement,
  action: "left" | "right" | "up" | "down",
  setView: (view: SettingsView) => void,
): HTMLElement | undefined => {
  const allGamepadElements = document?.querySelectorAll("[data-gamepad]");
  const listElement = Array.from(allGamepadElements || []) as HTMLElement[];
  const currentActiveMenuElement = listElement.find(
    (item) => item.getAttribute("data-gamepad") === getMenuGamepadId(),
  );

  const dataGamepad = activeElement?.getAttribute("data-gamepad");
  const activeMenu = listElement.find((item) =>
    item.getAttribute("data-setting-active"),
  );

  const isSettingsIcon =
    dataGamepad === currentActiveMenuElement?.getAttribute("data-gamepad");
  const isSettingMenu = dataGamepad?.startsWith("setting-menu-");
  const isContentArea = !isSettingMenu && !dataGamepad?.startsWith("menu-");

  // ========== From sidebar menu icon into setting menu ==========

  if (isSettingsIcon && action === "down") {
    return activeMenu || undefined;
  }

  // ========== Setting menu navigation ==========

  if ((action === "down" || action === "up") && isSettingMenu) {
    if (!activeElement || !action) return undefined;
    const nextElement = onDefaultMoveAction(activeElement, action);
    const nextGamepad = nextElement?.getAttribute("data-gamepad");
    if (nextGamepad?.startsWith("setting-menu-")) {
      const nextView = nextElement?.getAttribute("data-setting-view");
      if (nextView) setView(nextView as SettingsView);
      return nextElement;
    }
    if (action === "up") return currentActiveMenuElement || undefined;
    return undefined;
  }

  if (action === "right" && isSettingMenu) {
    const id = activeElement.getAttribute("data-gamepad-id");
    if (id) activeElementsByPage.set(getRoutePath(), id);
    return findFirstContentElement(listElement) || undefined;
  }

  // ========== Content-specific overrides ==========

  if (
    dataGamepad === "legal-content" &&
    (action === "up" || action === "down")
  ) {
    const top = action === "down" ? SCROLL_AMOUNT : -SCROLL_AMOUNT;
    const iframe = activeElement?.querySelector("iframe");
    let scrollIframe = false;
    if (iframe?.contentWindow) {
      try {
        iframe.contentWindow.scrollBy({ top, behavior: "smooth" });
        scrollIframe = true;
      } catch {
        scrollIframe = false;
      }
    }

    if (!scrollIframe) {
      activeElement?.scrollBy({ top, behavior: "smooth" });
    }
    return undefined;
  }

  if (dataGamepad === "avatar-select") {
    if (action === "left" || action === "right") {
      const avatars = listElement.filter(
        (item) => item.getAttribute("data-gamepad") === "avatar-select",
      );
      const currentIndex = avatars.indexOf(activeElement as HTMLElement);
      if (action === "left") {
        if (currentIndex > 0) return avatars[currentIndex - 1];
        return activeMenu || undefined;
      }
      if (currentIndex < avatars.length - 1) return avatars[currentIndex + 1];
      return undefined;
    }
  }

  // ========== General content navigation ==========

  if (action === "left" && isContentArea) {
    return activeMenu || undefined;
  }

  if ((action === "down" || action === "up") && isContentArea) {
    if (!activeElement || !action) return undefined;
    const contentElements = listElement.filter((item) =>
      isContentElement(item.getAttribute("data-gamepad")),
    );
    return getNextElement(contentElements, activeElement, action) || undefined;
  }

  if (!activeElement || !action) return undefined;
  return onDefaultMoveAction(activeElement, action);
};

export const onSubmitSettingsAction = (
  activeElement: HTMLElement | undefined,
  setActiveElement: (element: HTMLElement) => void,
) => {
  if (!activeElement) return;
  const ctx = getGamepadElementContext(activeElement);
  const { listElement } = ctx;

  const dataGamepad = activeElement?.getAttribute("data-gamepad");
  const isSettingMenu = dataGamepad?.startsWith("setting-menu-");

  if (isSettingMenu) {
    const firstContent = findFirstContentElement(listElement);
    if (firstContent) {
      setActiveElement(firstContent);
    }
  }

  activeElement?.click();
};

export const onBackSettingsAction = (
  activeElement: HTMLElement | undefined,
  setActiveElement: (element: HTMLElement) => void,
  view?: SettingsView,
  setView?: (view: SettingsView) => void,
) => {
  if (!activeElement) return;
  const ctx = getGamepadElementContext(activeElement);
  const { listElement } = ctx;

  const activeMenu = listElement.find((item) =>
    item.getAttribute("data-setting-active"),
  );

  const dataGamepad = activeElement?.getAttribute("data-gamepad");
  const isSettingMenu = dataGamepad?.startsWith("setting-menu-");
  const isNavbarMenu = dataGamepad?.startsWith("menu-");

  if (isNavbarMenu) {
    const consoleMenuElement = listElement.find(
      (item) => item.getAttribute("data-gamepad") === "menu-/",
    );
    if (consoleMenuElement) {
      setActiveElement(consoleMenuElement);
      consoleMenuElement.click();
    }
    return;
  }

  if (!isSettingMenu && setView && view && LEGAL_DETAIL_VIEWS.includes(view)) {
    setView(SettingsView.LegalInformation);
    focusGamepadElementNextFrame(
      `[data-gamepad="settings-content-${view}"]`,
      setActiveElement,
    );
    return;
  }

  if (!isSettingMenu && setView && view && COOKIE_DETAIL_VIEWS.includes(view)) {
    setView(SettingsView.CookieSettings);
    focusGamepadElementNextFrame(
      `[data-gamepad="settings-content-${view}"]`,
      setActiveElement,
    );
    return;
  }

  if (
    !isSettingMenu &&
    setView &&
    view &&
    GENERAL_DETAIL_VIEWS.includes(view)
  ) {
    setView(SettingsView.General);
    focusGamepadElementNextFrame(
      `[data-gamepad="settings-content-${view}"]`,
      setActiveElement,
    );
    return;
  }

  if (isSettingMenu) {
    const settingsIcon = getFirstElementStartsWithId(getMenuGamepadId());
    if (settingsIcon) setActiveElement(settingsIcon);
  } else {
    if (activeMenu) setActiveElement(activeMenu);
  }
};

export const onGetNextElement = (gamepadId: string) => {
  const elements = Array.from(
    document.querySelectorAll(`[data-gamepad="${gamepadId}"]`),
  ) as HTMLElement[];
  const nextElement = findStartElementByClientRect(elements);
  return nextElement;
};

export const onMoveHomeCards = (
  activeElement?: HTMLElement,
  action?: "left" | "right" | "up" | "down",
): HTMLElement | undefined => {
  if (!activeElement || !action) return undefined;
  const listRowIds = [
    "header-profile-avatar",
    "game-card-recent",
    "slide-",
    "game-card-essential-pass",
    "game-card-install-play",
  ];
  const dataGamepad = activeElement?.getAttribute("data-gamepad");
  const isSlideCards = dataGamepad?.startsWith("slide-");
  const ctx = getGamepadElementContext(activeElement);
  const { isActiveMenu, listContentElement, currentActiveMenuElement } = ctx;

  if (isActiveMenu) {
    return handleMenuNavigation(ctx, action);
  }

  if (
    isSlideCards &&
    dataGamepad !== "slide-static" &&
    ["left", "right"].includes(action)
  ) {
    return;
  }

  const nextElement = getNextElement(listContentElement, activeElement, action);
  if (action === "up" && !nextElement && hasNavigationBar()) {
    return currentActiveMenuElement;
  } else if (action === "down" || action === "up") {
    const currentRowIndex = listRowIds.findIndex((rowId) =>
      dataGamepad?.startsWith(rowId),
    );
    const step = action === "up" ? -1 : 1;
    let nextRowElements: HTMLElement[] = [];
    for (
      let rowIndex = Math.max(currentRowIndex, 0) + step;
      rowIndex >= 0 && rowIndex < listRowIds.length && !nextRowElements.length;
      rowIndex += step
    ) {
      nextRowElements = listContentElement.filter((item) =>
        item.getAttribute("data-gamepad")?.startsWith(listRowIds[rowIndex]),
      );
    }
    const closestElementByRow = findStartElementByClientRect(nextRowElements);
    return closestElementByRow;
  } else {
    const test = findNextElementByRowId(
      activeElement,
      action,
      listContentElement,
    );
    return test;
  }
};

export const isSliderElement = (activeElement: HTMLElement | undefined) => {
  const dataGamepad = activeElement?.getAttribute("data-gamepad");
  return dataGamepad?.startsWith("slide-");
};

export const onMoveGamePlayMenu = (
  activeElement?: HTMLElement,
  action?: "left" | "right" | "up" | "down",
): HTMLElement | undefined => {
  if (!activeElement || !action) return undefined;

  const nextElement = onDefaultMoveAction(activeElement, action);

  if (!nextElement && action === "down") {
    const menuElement = document.getElementById("menu-inner");
    const isScrolledToBottom = menuElement
      ? Math.ceil(menuElement.scrollTop + menuElement.clientHeight) >=
        menuElement.scrollHeight
      : true;
    if (!isScrolledToBottom) {
      menuElement?.scrollTo({
        top: menuElement?.scrollHeight,
        behavior: "smooth",
      });
    }
  }

  return nextElement;
};

export const handleStreamingProfileBack = ({
  hasExpandedDropdown,
  collapse,
  close,
}: {
  hasExpandedDropdown: boolean;
  collapse: () => void;
  close: () => void;
}): void => {
  if (hasExpandedDropdown) {
    collapse();
    return;
  }
  close();
};
